export default "__VITE_ASSET__UOSriKVT__"